import {
  SET_HB_GAME_NAMES,
  SET_HB_GAME_IMAGES,
  SET_HB_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  hbNames: [],
  hbImages: [],
  hbPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HB_GAME_NAMES:
      return { ...state, hbNames: action.payload }
    case SET_HB_GAME_IMAGES:
      return { ...state, hbImages: action.payload };
    case SET_HB_GAME_POLA:
      return { ...state, hbPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;